export default "__VITE_ASSET__283799f7__"